export default {
  namespaced: true,

  state: {
    scheduledEmailsList: [],
    scheduledEmailsData: {},
    editItem: null,
    isLoading: false,
    error: null
  },
  getters: {
    scheduledEmailsList(state) {
      return state.scheduledEmailsList
    },
    scheduledEmailsData(state) {
      return state.scheduledEmailsData
    },
    editItem(state) {
      // console.log(state.editItem)
      return state.editItem
    },
    isLoading(state) {
      return state.isLoading
    },
    error(state) {
      return state.error
    },
  },
  mutations: {
    SET_EMAIL_SCHEDULES(state, scheduledEmailsList) {
      state.scheduledEmailsList = scheduledEmailsList 
    },
    SET_EMAIL_SCHEDULE_DATA(state, scheduledEmailsData) {
      state.scheduledEmailsData = scheduledEmailsData
    },
    GET_EMAIL_SCHEDULE(state, index) {
      let editItemIndex = state.scheduledEmailsList.map(function(item) { return item.id; }).indexOf(parseInt(index));
      state.editItem = state.scheduledEmailsList[editItemIndex]
    },
    SET_LOADING_STATUS(state, isLoading) {
      state.isLoading = isLoading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    REMOVE_ROW(state, index) {
      let removeIndex = state.scheduledEmailsList.map(function(item) { return item.id; }).indexOf(index);
      state.scheduledEmailsList.splice(removeIndex, 1);
    },
  },
  actions: {
    deleteRow({commit}, dispatch_data) {
      commit('REMOVE_ROW', dispatch_data.id)
    },
  }
}
